import { ErpDataTableV2 } from '@/components/custom/erp';

import React, { useState } from 'react';
import InitialSearchDialog from './components/InitialSearchDialog';
import { EditPrintTemplateDialog } from './components';
import { tableColumns } from './col-definition';
import ActionBar from './components/ActionBar';
import { QUERY_KEYS } from '@/constants';
import { useDialogState } from './hooks';
import { useReport } from '@/hooks';

export default function DebtBalanceReportPage() {
  const {
    initialSearchDialogOpen,
    editPrintTemplateDialogOpen,
    showTable,

    handleInitialSearchClose,
    handleInitialSearch,
    handleSearchClick,
    handleEditPrintTemplateClick,
    handleClosePrintTemplateDialog,
    handleSavePrintTemplate
  } = useDialogState();

  const [searchParams, setSearchParams] = useState<BanHangRecord>(null);
  const [searchFieldStates, setSearchFieldStates] = useState<BanHangRecord>({});

  const { getReport, data, isLoading, refreshData, currentPage, handlePageChange, totalItems } = useReport({
    endpoint: QUERY_KEYS.BAO_CAO_SO_DU_CONG_NO_BH,
    pageSize: 50
  });

  const handleSearchWithData = async (values: BanHangPayload) => {
    try {
      await getReport(values.data);
      setSearchFieldStates({ account: values.tk });
      setSearchParams(values.data);
      handleInitialSearchClose();
    } catch (error) {
      return;
    }
  };

  const handleRefreshWithData = async () => {
    await refreshData();
  };

  const tables = [
    {
      name: '',
      columns: tableColumns,
      rows: data
    }
  ];

  return (
    <div className='flex h-full min-h-[calc(100vh-64px)] w-screen flex-col overflow-auto'>
      {initialSearchDialogOpen && (
        <InitialSearchDialog onClose={handleInitialSearchClose} onSearch={handleSearchWithData} />
      )}

      <EditPrintTemplateDialog
        open={editPrintTemplateDialogOpen}
        onClose={handleClosePrintTemplateDialog}
        onSave={handleSavePrintTemplate}
      />

      {searchParams && (
        <>
          <ActionBar
            onSearchClick={handleSearchClick}
            onRefreshClick={handleRefreshWithData}
            onFixedColumnsClick={() => {}}
            onExportDataClick={() => {}}
            onEditPrintTemplateClick={handleEditPrintTemplateClick}
            className='border-b border-gray-200'
            searchParams={{
              ngay_ct: searchParams.ngay_ct,
              account: searchFieldStates.account
            }}
          />

          <div className='flex-1 overflow-hidden'>
            {!isLoading && (
              <ErpDataTableV2
                tables={tables}
                pageSize={50}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                totalItems={totalItems}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
}
